module.exports = __webpack_public_path__ + "img/list.e575598a.svg";